const status = state => state.status
const message = state => state.message
const redirect = state => state.redirect

export default {
  status,
  message,
  redirect
}
